import Notify from "@/notifications/Notify";

let key = 0;
export default {
    install(Vue)
    {
        Vue.component("notify", Notify)
        Vue.prototype.$notifications = Vue.observable({items: []});
        Vue.notify = (title, text, type) =>{
            if (Vue.prototype.$notifications.items.length >= 3)
            {
                Vue.prototype.$notifications.items.shift();
            }
            let notify = {title, text,type, key: key}
            key++;
            setTimeout(()=>{Vue.prototype.$notifications.items.push(notify)},100);
            setTimeout(()=>{
                Vue.closeNotify(notify);
            }, 5000)
        }

        Vue.closeNotify = (notify) =>{
            let index = Vue.prototype.$notifications.items.indexOf(notify)
            if (index >=0)
            {
                Vue.prototype.$notifications.items.splice(index,1);
            }

        }

    }
}
